import { action, createAsyncAction } from 'typesafe-actions';
import ActionTypes from './constants';
import { ContactUsForm } from '../../ContactUsPage/types.d';
import { WriteContactUsInfoInput } from 'types/schema';

export const productsSource = createAsyncAction(
  ActionTypes.PRODUCTS_SOURCE_REQUEST,
  ActionTypes.PRODUCTS_SOURCE_SUCCESS,
  ActionTypes.PRODUCTS_SOURCE_FAILURE,
)<any, {}, { [key: string]: { data: []; error: boolean } }>();

export const setProductSourceFavorite = (data: any) => action(ActionTypes.PRODUCTS_SOURCE_FAVORITE, data);

export const productSourceFavorite = createAsyncAction(
  ActionTypes.PRODUCTS_SOURCE_FAVORITE_REQUEST,
  ActionTypes.PRODUCTS_SOURCE_FAVORITE_SUCCESS,
  ActionTypes.PRODUCTS_SOURCE_FAVORITE_FAILURE,
)<void, {}, {}>();

export const setProductSourceNote = (data: any) => action(ActionTypes.SET_PRODUCT_NOTE, data);

export const productSourceSetNote = createAsyncAction(
  ActionTypes.SET_PRODUCT_NOTE_REQUEST,
  ActionTypes.SET_PRODUCT_NOTE_SUCCESS,
  ActionTypes.SET_PRODUCT_NOTE_FAILURE,
)<void, {}, Error>();

export const getMoreSectionData = (data: any) => action(ActionTypes.GET_MORE_SECTION_DATA, data);
export const initDataPage = () => action(ActionTypes.PRODUCTS_SOURCE_INIT);

export const contactUsSubmit = (data: { values: ContactUsForm; cb: () => void }) =>
  action(ActionTypes.CONTACT_US_SUBMIT, data);

export const contactUs = createAsyncAction(
  ActionTypes.CONTACT_US_REQUEST,
  ActionTypes.CONTACT_US_SUCCESS,
  ActionTypes.CONTACT_US_FAILURE,
)<void, void, Error>();

export const checkEmailSubmit = (values: any) => action(ActionTypes.CHECK_EMAIL_SUBMIT, values);

export const checkEmail = createAsyncAction(
  ActionTypes.CHECK_EMAIL_REQUEST,
  ActionTypes.CHECK_EMAIL_SUCCESS,
  ActionTypes.CHECK_EMAIL_FAILURE,
)<void, {}, Error>();

export const submitContactUsShortForm = (values: { data: WriteContactUsInfoInput; cb: () => void }) =>
  action(ActionTypes.CONTACT_US_SHORT_FORM_REQUEST, values);
